import { Flex, Box } from '@cad-arc';
import { EventSearchOptions, EventSearchStatics } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { FormUserMultiSelect } from '../forms/integrated-form-controls/form-user-multi-select';
import { EventSearchFormType } from './types';
import { FormSection } from '../search-windows/form-section';
import { INPUT_WIDTH_SM } from '../search-windows/constants';

export function EventSearchFormSecondarySection({
    form,
    options,
    statics,
}: Readonly<{
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
    statics: EventSearchStatics;
}>) {
    const { hospitalsEnabled, radioChannels, eventLabels } = useEnabledFeatures();
    return (
        <FormSection title="More Search Fields" width="100%">
            <Flex flex={1} flexFlow="wrap" gap="1rem">
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="dispatched"
                        label="Dispatched"
                        control={form.control}
                        options={options.dispatchedOptions}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="reportingEventNumberGenerated"
                        label={`${statics.reportingEventNumberDisplayName} Generated`}
                        control={form.control}
                        options={options.reportingEventNumberGeneratedOptions}
                    />
                </Box>
                {eventLabels && (
                    <Box w={INPUT_WIDTH_SM}>
                        <FormSelect
                            name="eventLabels"
                            label="Labels"
                            control={form.control}
                            options={options.eventLabelOptions}
                            isMultiple
                            truncateSelectedCount={2}
                        />
                    </Box>
                )}
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="priorities"
                        label="Priority Levels"
                        control={form.control}
                        options={options.priorityOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="agencyProfiles"
                        label="Agencies"
                        control={form.control}
                        options={options.agencyProfileOptions}
                        isMultiple
                        truncateSelectedCount={3}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="assistingAgencyProfiles"
                        label="Assisting Agencies"
                        control={form.control}
                        options={options.agencyProfileOptions}
                        isMultiple
                        truncateSelectedCount={3}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="agencyType"
                        label="Agency Type"
                        control={form.control}
                        options={options.agencyTypeOptions}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="dispatchAreas"
                        label="Dispatch Areas"
                        control={form.control}
                        options={options.dispatchAreaOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
                {radioChannels && (
                    <Box w={INPUT_WIDTH_SM}>
                        <FormSelect
                            name="radioChannels"
                            label="Radio Channels"
                            control={form.control}
                            options={options.radioChannelOptions}
                            isMultiple
                            truncateSelectedCount={2}
                        />
                    </Box>
                )}
                {hospitalsEnabled && (
                    <Box w={INPUT_WIDTH_SM}>
                        <FormSelect
                            name="hospitals"
                            label="Hospitals"
                            control={form.control}
                            options={options.hospitalOptions}
                            isMultiple
                            truncateSelectedCount={2}
                        />
                    </Box>
                )}
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="eventOrigins"
                        label="Call Origins"
                        control={form.control}
                        options={options.eventOriginOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="eventQueue"
                        label="Call Type"
                        control={form.control}
                        options={options.eventQueueOptions}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormUserMultiSelect
                        name="dispatchers"
                        label="Dispatchers"
                        control={form.control}
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormUserMultiSelect
                        name="callTakers"
                        label="Call Takers"
                        control={form.control}
                        truncateSelectedCount={2}
                    />
                </Box>
                <Box w={INPUT_WIDTH_SM}>
                    <FormSelect
                        name="callForServices"
                        label="Calls For Service"
                        control={form.control}
                        options={options.callForServiceOptions}
                        isMultiple
                        truncateSelectedCount={2}
                    />
                </Box>
            </Flex>
        </FormSection>
    );
}
